module.exports = __webpack_public_path__ + "static/media/pulmonology-icon@3x.472a6687.png";